import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ClientsActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить клиента ${_ctx.state.name}?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        placeholder: "Название"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-3",
        value: _ctx.state.redirect,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.redirect) = $event)),
        "is-invalid": _ctx.state_form$.redirect.$error,
        "validation-errors": _ctx.state_form$.redirect.$errors,
        placeholder: "Redirect URL"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        value: _ctx.state.scopes,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.scopes) = $event)),
        placeholder: "Скоупы",
        "is-invalid": _ctx.state_form$.scopes.$error,
        "validation-errors": _ctx.state_form$.scopes.$errors,
        loading: _ctx.data_state.scopes.is_loading,
        options: _ctx.data_state.scopes.list,
        failed: _ctx.data_state.scopes.is_failed,
        "error-text": "При получении списка скоупов произошла ошибка",
        "infinite-scroll": "",
        multiselect: "",
        label: "scope",
        "select-by": "id",
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadScopes(_ctx.data_state.scopes.pagination.current_page))),
        onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreScopes(_ctx.data_state.scopes.pagination.current_page + 1)))
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        value: _ctx.state.user_id,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.user_id) = $event)),
        placeholder: "Пользователь",
        loading: _ctx.data_state.users.is_loading,
        options: _ctx.data_state.users.list,
        failed: _ctx.data_state.users.is_failed,
        "error-text": "При получении списка пользователей произошла ошибка",
        "infinite-scroll": "",
        "search-by": "email",
        "select-by": "id",
        label: "email",
        onRefresh: _ctx.refreshUsers,
        onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreUsers(_ctx.data_state.users.pagination.current_page + 1))),
        onSearch: _ctx.searchUser,
        class: "mt-3"
      }, null, 8, ["value", "loading", "options", "failed", "onRefresh", "onSearch"]),
      _createVNode(_component_checkbox, {
        class: "mt-3",
        value: _ctx.state.password,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.password) = $event)),
        label: "Password client"
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        class: "mt-3",
        value: _ctx.state.personalToken,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.personalToken) = $event)),
        label: "Personal token"
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        class: "mt-3",
        value: _ctx.state.serviceClient,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.serviceClient) = $event)),
        label: "Service client"
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}